module.exports = __webpack_public_path__ + "/92c219fb4e1d6b7b86b196575fd480bc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/macbook_@2x.png
 ** module id = 1536
 ** module chunks = 0
 **/